
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports",
      function () {
        return require("private-next-pages/reports/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports"])
      });
    }
  